import { Ruleset } from "@shared/types";

import { authDelete } from "../auth";

export const deleteUserRule = (rulesetName: string) =>
  authDelete<Ruleset>(`/api/registry/rulesets/${rulesetName}`);
